const { logger, bigQuery } = require('@fiverr-private/obs');

const { PAGE_TYPE_CONFIG } = require('../utils/pageTypesConfig');

const missingMixpanelException = 'MixpanelWrapper is missing in window';

const pageViewedMP = (data) => {
    if (typeof MixpanelWrapper === 'undefined') {
        return logger.error(missingMixpanelException);
    }

    if (!data) {
        return logger.error('Mixpanel pageViewed event sending failure');
    }

    const mpEvent = PAGE_TYPE_CONFIG[data.pageInfo.pageType].getMixpanelPageViewEvent(data);

    MixpanelWrapper.trackPageView(mpEvent.pageName, mpEvent.payload);
};

const pageViewedBQ = ({ context, data = {} }) => {
    if (typeof bigQuery === 'undefined') {
        return logger.error('bigQuery is missing in window');
    }

    const bqEvent = PAGE_TYPE_CONFIG[data.pageInfo.pageType].getBigqueryPageViewEvent(context, data);

    bigQuery.send(bqEvent);
};

const pageViewed = (context) => (data) => {
    pageViewedMP(data);
    pageViewedBQ({ context, data });
};

const useTracker = (context) => ({
    pageViewed: pageViewed(context)
});

module.exports = {
    pageViewed,
    useTracker
};
